__webpack_require__.p = "/diplom-project-2023/";